<template>
  <div class="refundGuide ql-container ql-snow">
    <!--# 반품 / 교환 안내 -->
    <a
      class="accordionBtn"
      @click="toggleAccordion"
      :class="open ? 'open' : ''"
    >
      <span class="accordionTitle">반품/교환 안내</span>
      <i class="icon iconDown2" :class="open ? 'iconUp2' : 'iconDown2'"></i>
    </a>
    <transition name="accordion">
      <div class="accordionData" :class="open ? 'open' : ''">
        <div class="ql-editor" v-html="refundExchangeDesc" />
      </div>

      <!-- <div class="accordionData" :class="open?'open':''">
          <p class="info"><span>지정 택배사</span>우체국택배</p>
          <p class="info"><span>반품 배송비</span>편도 2,500원</p>
          <p class="info"><span>교환배송비</span>5,000원</p>
          <p class="info"><span>보내실곳</span>경기 성남시 분당구 판교로 256번길 7</p>

          <p class="comment">
            교환/반품 시 진행에 필요한 왕복 배송비 및 기타 필요한 비용은
            귀책사유가 있는 쪽에서 부담합니다.
            회사와 회원간 권리, 의무에 관한 문제가 발생할 경우, 관련 법령이
            정한 절차에 따릅니다.
          </p>

          <dl class="descList">
            <dt>아이템 쿠폰</dt>
            <dd>구매확정을 하지 않은 경우 구매 7일까지는, 넥슨쇼핑 > MY 페이지 > 내 쿠폰함 > 쿠폰상세에서 청약철회 할 수 있습니다.</dd>
            <dd>구매 7일이 지나 구매확정 된 경우 혹은 환불, 소비자 피해보상, 기타 문의는 고객센터를 이용해 주세요.</dd>

            <dt>일반배송상품</dt>
            <dd>상품을 배송받은 후 7일 이내에 고객센터를 통해 교환/반품을 신청할
              수 있습니다. 단, 제품의 표시광고 내용과 다르거나 불량 등 계약과
              다르게 이행된 경우는 제품 수령일부터 3개월 이내, 그 사실을 안 날
              또는 알 수 있었던 날부터 30일 이내에 교환/반품이 가능합니다.
              필요시, 하자판단을 위한 증빙자료를 요청할 수 있습니다.</dd>

            <dt>펀딩상품</dt>
            <dd>하자가 있는 경우에 한해, 상품을 배송받은 후 7일 이내에 고객센터를
              통해 교환 신청할 수 있습니다. 제품의 표시광고 내용과 다르거나
              불량 등 계약과 다르게 이행된 경우에는 환불을 요구할 수 있습니다.
              필요시, 하자판단을 위한 증빙자료를 요청할 수 있습니다.</dd>

            <dt>반품/교환 신청 불가사유</dt>
            <dd>소비자의 책임 있는 사유로 상품 등이 멸실 또는 훼손된 경우 (단지, 상품 확인을 위한 포장 훼손 제외)</dd>
            <dd>소비자의 사용 또는 소비에 의해 상품 등의 가치가 현저히 감소한 경우</dd>
            <dd>시간의 경과에 의해 재판매가 곤란할 정도로 상품 등의 가치가 현저히 감소한 경우</dd>
            <dd>복제가 가능한 상품 등의 포장을 훼손한 경우</dd>
            <dd>소비자의 주문에 따라 개별적으로 생산되는 상품이 제작에 들어간 경우(펀딩상품에 해당)</dd>
            <dd>그 밖에, 특이사항은 각 상품상세설명에서 확인</dd>
          </dl>

          <p class="comment">
            이외 기타 문의사항이 있으시면 넥슨 고객센터로 문의해 주시기
            바랍니다.
          </p>
        </div> -->
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    refundExchangeDesc: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      open: true
    }
  },
  methods: {
    toggleAccordion() {
      this.open = !this.open
    }
  }
}
</script>
